import React from "react";
import OrderList from "./OrderList";

function App() {
  return (
    <div>
      <OrderList />
    </div>
  );
}

export default App;
